import { useForm } from "react-hook-form";
import { Box, Button, FormControl, FormLabel, TextField, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLinkedinDeal, saveLinkedinDeal, saveLinkedinDealReset } from "../../state/linkedinPromotion/linkedinPromotionSlice";
import { selectLinkedinPromotionState } from "../../state/linkedinPromotion/linkedinPromotionSelector";

const LinkedinSlotsModal = ({ onClose, companyInfo }) => {
  const dispatch = useDispatch();
  const { deal, isLoading, isSaving, isSaveSuccess } = useSelector(selectLinkedinPromotionState);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      totalSlots: 0,
      expireDate: "",
      monthlyCreditAmount: 0,
      linkedInCompanyId: "",
      linkedInCompanyName: "",
    },
  });

  useEffect(() => {
    if (companyInfo?.id) {
      dispatch(getLinkedinDeal(companyInfo.id));
    }
  }, [companyInfo?.id, dispatch]);

  useEffect(() => {
    if (deal) {
      reset({
        totalSlots: deal.totalSlots,
        expireDate: deal.expireDate ? deal.expireDate.split("T")[0] : "",
        monthlyCreditAmount: deal.monthlyCreditAmount,
        linkedInCompanyId: deal.linkedInCompanyId || "",
        linkedInCompanyName: deal.linkedInCompanyName || "",
      });
    }
  }, [deal, reset]);

  useEffect(() => {
    if (isSaveSuccess) {
      dispatch(saveLinkedinDealReset());
      onClose();
    }
  }, [isSaveSuccess, dispatch, onClose]);

  const onSubmit = (data) => {
    const payload = {
      ...data,
      companyId: companyInfo.id,
    };

    if (deal?.id) {
      payload.id = deal.id;
    }

    dispatch(saveLinkedinDeal(payload));
  };

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      <FormControl fullWidth>
        <FormLabel sx={{ mb: 1 }}>Number of Slots</FormLabel>
        <TextField
          size="small"
          type="number"
          {...register("totalSlots", {
            valueAsNumber: true,
            required: "Number of slots is required",
            min: { value: 1, message: "Must be at least 1" },
          })}
          error={!!errors.totalSlots}
          helperText={errors.totalSlots?.message}
        />
      </FormControl>

      <FormControl fullWidth>
        <FormLabel sx={{ mb: 1 }}>Contract Expiry Date</FormLabel>
        <TextField
          size="small"
          type="date"
          {...register("expireDate", {
            required: "Expiry date is required",
          })}
          InputLabelProps={{
            shrink: true,
          }}
          error={!!errors.expireDate}
          helperText={errors.expireDate?.message}
        />
      </FormControl>

      <FormControl fullWidth>
        <FormLabel sx={{ mb: 1 }}>Monthly discount deal amount for all Slots</FormLabel>
        <TextField
          size="small"
          type="number"
          {...register("monthlyCreditAmount", {
            valueAsNumber: true,
            required: "Monthly discount deal amount is required",
            min: { value: 0, message: "Must be >= 0" },
          })}
          error={!!errors.monthlyCreditAmount}
          helperText={errors.monthlyCreditAmount?.message}
        />
      </FormControl>

      <FormControl fullWidth>
        <FormLabel sx={{ mb: 1 }}>LinkedIn Company ID</FormLabel>
        <TextField
          size="small"
          {...register("linkedInCompanyId", {
            required: "LinkedIn Company ID is required",
          })}
          error={!!errors.linkedInCompanyId}
          helperText={errors.linkedInCompanyId?.message}
        />
      </FormControl>

      <FormControl fullWidth>
        <FormLabel sx={{ mb: 1 }}>LinkedIn Company Name</FormLabel>
        <TextField
          size="small"
          {...register("linkedInCompanyName", {
            required: "LinkedIn Company Name is required",
          })}
          error={!!errors.linkedInCompanyName}
          helperText={errors.linkedInCompanyName?.message}
        />
      </FormControl>

      <Button type="submit" variant="contained" sx={{ mt: 2 }} disabled={isSaving}>
        {isSaving ? "Saving..." : deal?.id ? "Update & Save" : "Confirm & Assign"}
      </Button>
    </Box>
  );
};

export default LinkedinSlotsModal;
